module.exports = __webpack_public_path__ + "img/3_13.196e4671.png";